module.exports = __webpack_public_path__ + "static/media/33.b9df559e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/33.jpg
// module id = 402
// module chunks = 0